export default "__VITE_ASSET__8d0d73a1__"